import { ErrorHandler, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ApolloError } from '@apollo/client/core';
import { flatMap as _flatMap } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  constructor(
    private errorHandler: ErrorHandler,
    private snackBar: MatSnackBar
  ) {
  }

  /**
   * Shows success message
   *
   * @param message
   * @param action
   * @param options MatSnackBarConfig options
   */
  public success(
    message: string,
    action: string = null,
    options: MatSnackBarConfig = {}
  ) {

    const defaultOpts: MatSnackBarConfig = {
      duration: 5000,
      panelClass: 'green-snackbar',
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    };

    return this.snackBar.open(message, action, { ...defaultOpts, ...options });
  }

  public warning(
    message: string,
    action: string = null,
    options: MatSnackBarConfig = {}
  ) {

    const defaultOpts: MatSnackBarConfig = {
      duration: 5000,
      panelClass: 'orange-snackbar',
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    };

    this.snackBar.open(message, action, { ...defaultOpts, ...options });
  }

  public info(
    message: string,
    action: string = null,
    options: MatSnackBarConfig = {}
  ) {

    const defaultOpts: MatSnackBarConfig = {
      duration: 5000,
      panelClass: 'blue-snackbar',
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    };

    return this.snackBar.open(message, action, { ...defaultOpts, ...options });
  }

  public error(
    message: string | ApolloError | Error,
    action: string = null,
    options: MatSnackBarConfig = {}
  ) {
    const defaultOpts: MatSnackBarConfig = {
      duration: 5000,
      panelClass: 'red-snackbar',
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    };

    // TODO: Generally refactor the error handling
    this.errorHandler.handleError(message);
    return this.snackBar.open(this.buildMessage(message), action, { ...defaultOpts, ...options });
  }

  public errorSkipLog(
    message: string | ApolloError | Error,
    action: string = null,
    options: MatSnackBarConfig = {}
  ) {

    const defaultOpts: MatSnackBarConfig = {
      duration: 5000,
      panelClass: 'red-snackbar',
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    };

    return this.snackBar.open(this.buildMessage(message), action, { ...defaultOpts, ...options });
  }

  private buildMessage(message: string | ApolloError | Error) {
    // eslint-disable-next-line no-console
    console.error(message);

    let msg = 'An error has occured and has been sent to the team.';
    if (typeof message === 'string') {
      msg = message;
    } else {
      const apolloError = message as ApolloError;
      if (apolloError.graphQLErrors) {
        const errorMessage = _flatMap(apolloError.graphQLErrors, e => e.message).join('<br>');
        msg = errorMessage;
      }
    }

    return msg;
  }
}
